<div class="centralDiv">
  <div>
    <h3 class="start_letter">
        Recuperación de Contraseña
    </h3>
</div>
<div>
    <form [formGroup]="formChangePassword" (ngSubmit)="changePasword()">
        <div>
          <mat-form-field class="full-width-input" style="text-align: center">
            <input matInput placeholder="Contraseña Nueva" formControlName="newPassword" required type="password" />
          </mat-form-field>
        </div>
        <div style="margin-bottom: 1.5em;">
          <mat-form-field class="full-width-input" style="text-align: center">
            <input matInput type="password" placeholder="Repite tu contraseña nueva" formControlName="repeatNewPassword" required />
          </mat-form-field>
        </div>
        <button class="btnEntrar" type="submit">
          <div>
            <img src="../../../../../assets/img/icon_entrar.png" alt="Image" style="width: 1.3em;">
          </div>
          <div>
            Recuperar Contraseña
          </div>
        </button>
      </form>
</div>
</div>